import { createSlice } from "@reduxjs/toolkit"


var data=[]


if (localStorage.getItem("farmer") !== null && localStorage.getItem("farmer") !== undefined && localStorage.getItem("farmer") !== "") {

    data = JSON.parse(localStorage.getItem("farmer"))

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {
        getfarmer: (state, action) => {
            localStorage.setItem("farmer", JSON.stringify(action.payload.data))
            state = action.payload.data
            return state
        
          
        },

    },

})

export const { seedetails, home, getfarmer } = Insider.actions;
export default Insider.reducer;